



export function reduceByUniqueId(acc,item) {
    return acc.findIndex(v => v.id === item.id ) < 0 ? acc.concat(item): acc.concat([])
  }
  
  
  
export function sortByLevelId(a, b) {
    const nameA = a.levelId
    const nameB = b.levelId
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1
    return 0
  }
  
export function sortByIndicatorId(a, b) {
    const nameA = a.indicatorId
    const nameB = b.indicatorId
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1
    return 0
  }
  


function formatIndicators(indicators,answers) {
    return indicators.map(indicator => {
      const filteredAnswers = answers.filter(answer => answer.indicatorId === indicator.id)
      indicator.count = filteredAnswers.length
      return indicator
    })
  }
  
  function formatLevels(levels, answers) {
    return levels.map(level => {
      const filteredAnswers = answers.filter(answer => answer.levelId === level.id)
      level.indicators = formatIndicators(level.indicators,filteredAnswers)    
  
      return level
    })
  }
  
  function formatCpsByAnswers(cps,answers) {
    return cps.map( cp =>
      { 
        cp.levels = formatLevels(cp.levels,answers)
  
        cp.counts = cp.levels.reduce( (acc, level) =>
          acc.map( (count,i) => count += level.indicators[i].count  ) ,[0,0,0]  )
  
        return cp
      })
  }
  
  export default (employeeId,assessments) => {
    // Look for the same employee id
    const filteredAssessment = assessments
      .filter(assessment => assessment.employee.id === employeeId)
  
    // merge and sort answers for later processing
    const answers = filteredAssessment
      .reduce( (accumulator,current) => accumulator.concat(current.answers), []  )
      .sort(sortByIndicatorId).sort(sortByLevelId)
  
    // merge activities
    const activities = filteredAssessment
      .reduce( (accumulator,current) => accumulator.concat(current.activities), []  )
  
    // fetch activity data
    let promises = activities
      .reduce( reduceByUniqueId ,[] )
      .map(activity => activity.get().then(doc => doc.data()) )
  
    return Promise.all(promises)
      .then(activities => activities
        .reduce( (accumulator, current) => accumulator.concat(current.competencies), [] )
        .reduce( reduceByUniqueId,[] ) )
      .then(cps => cps.map( cp => cp.get().then(doc => doc.data()) ) )
      .then(promises => Promise.all(promises).then(cps =>  formatCpsByAnswers(cps,answers)   ) ) 
    
  }


// WEBPACK FOOTER //
// ./src/assessments/utils/assessment-by-employee.js